import React from 'react';
import {Col, Row} from "antd";
const FULL_WIDTH = 24;
const ResponsiveRow = ((props) => {
    const {items, xs = FULL_WIDTH, sm = FULL_WIDTH, lg = FULL_WIDTH/items.length, xl = FULL_WIDTH/items.length} = props;
    return (
        <Row className={'padding--m ch-responsive-row'} gutter={[16,16]}>
            {items.map((item, index)=>{
                return (<Col key={index} className={'ch-responsive-col'} xs={xs} sm={sm} lg={lg} xl={xl}>
                    {item}
                </Col>)
            })}
        </Row>
    );
});

export default ResponsiveRow;